import * as types from '../constants/actionTypes';

const initialState = {
    width: window.innerWidth
};

export default function windowReducer(state = initialState, action) {
    switch(action.type) {
        case types.HANDLE_WINDOW_RESIZE:{
            return {
                ...state, 
                width: action.width
            }
        }
        default:
            return state;
    }
}
